// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { AiOutlinePlus } from "react-icons/ai";
// import Snackbar from '@mui/material/Snackbar';
// import { DataGrid } from "@mui/x-data-grid";
// import { useAuth } from '../context/AuthContext';

// // MUI components
// import { Container, Paper, Box, Grid, Typography, Card, CardContent, Button, Checkbox, CircularProgress } from "@mui/material";

// // MUI Icons used in mobile cards and DataGrid
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import ReportProblemIcon from '@mui/icons-material/ReportProblem';
// import LowPriorityIcon from '@mui/icons-material/LowPriority';

// // Helper function to format dates to dd-mm-yyyy
// const formatDate = (dateString) => {
//     if (!dateString || dateString === "N/A") return "N/A";
//     try {
//         // Handle both 'yyyy-mm-dd' and 'yyyy-mm-dd hh:mm:ss' formats
//         const date = new Date(dateString);
//         if (isNaN(date.getTime())) return "N/A"; // Invalid date
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     } catch (error) {
//         console.error("Error formatting date:", dateString, error);
//         return "N/A";
//     }
// };

// // Helper function to split records for team leader
// const splitRecordsForTeamLeader = (records, userId) => {
//     const selfRecords = records.filter((record) => record.userId === userId);
//     const teamRecords = records.filter((record) => record.userId !== userId);
//     return { self: selfRecords, team: teamRecords };
// };

// // Helper function to sort records for team leader
// const sortRecordsForTeamLeader = (records, userId) => {
//     const recs = Array.isArray(records) ? records : [];
//     return recs.sort((a, b) => {
//         const aIsSelf = a.userId === userId;
//         const bIsSelf = b.userId === userId;
//         if (aIsSelf && !bIsSelf) return -1;
//         if (!aIsSelf && bIsSelf) return 1;
//         const dateA = new Date(a.AddUserDateTime || "1970-01-01");
//         const dateB = new Date(b.AddUserDateTime || "1970-01-01");
//         return dateB - dateA;
//     });
// };

// // Helper: Return a color based on priority or status
// const getPriorityColor = (priority) => {
//     if (!priority) return "gray";
//     const p = String(priority).toLowerCase().trim();
//     if (p === "open") return "#388e3c"; // green
//     if (p === "close" || p === "closed") return "#d32f2f"; // red
//     switch (p) {
//         case "high": return "#d32f2f"; // red
//         case "medium": return "#fbc02d"; // amber
//         case "low": return "#388e3c"; // green
//         default: return "gray";
//     }
// };

// // Helper: Render a priority icon based on priority
// const renderPriorityIcon = (priority) => {
//     const color = getPriorityColor(priority);
//     if (!priority) return null;
//     switch (priority.toLowerCase()) {
//         case "high": return <PriorityHighIcon sx={{ color, mr: 0.5 }} />;
//         case "medium": return <ReportProblemIcon sx={{ color, mr: 0.5 }} />;
//         case "low": return <LowPriorityIcon sx={{ color, mr: 0.5 }} />;
//         default: return null;
//     }
// };

// const ComplainDetails = ({ connectionString }) => {
//     const { user, selectedCompany } = useAuth();
//     const path = connectionString;
//     // ----------------------- State Variables -----------------------
//     const [Complaint, setComplaint] = useState([]);
//     const [filters, setFilters] = useState({ complainDate: "", status: "", priority: "", clientname: "", clientContact: "", mobileNo: "" });
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [displayedRecords, setDisplayedRecords] = useState(0);
//     const batch = 10;
//     const navigate = useNavigate();
//     const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//     const [successMessage, setSuccessMessage] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [statusOptions, setStatusOptions] = useState([]);
//     const [priorityOptions, setPriorityOptions] = useState([]);
//     const [selectedIds, setSelectedIds] = useState([]);

//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory || null;

//     // ----------------------- Data Fetching and Side Effects -----------------------
//     useEffect(() => {
//         axios.get(`${path}/api/status`)
//             .then((res) => {
//                 if (res.data.success && Array.isArray(res.data.data)) {
//                     setStatusOptions(res.data.data);
//                 } else {
//                     setStatusOptions([]);
//                 }
//             })
//             .catch((error) => console.error("Error fetching status:", error));

//         axios.get(`${path}/api/priority`)
//             .then((res) => {
//                 if (res.data.success && Array.isArray(res.data.data)) {
//                     setPriorityOptions(res.data.data);
//                 } else {
//                     setPriorityOptions([]);
//                 }
//             })
//             .catch((error) => console.error("Error fetching priority options:", error));

//         fetchComplaint(false);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => setWindowWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // ----------------------- Function: fetchComplaint -----------------------
//     const fetchComplaint = async (isLoadMore = false, overrideFilters = null) => {
//         setLoading(true);
//         try {
//             const usedFilters = overrideFilters !== null ? overrideFilters : filters;
//             let offset = isLoadMore ? (Array.isArray(Complaint) ? Complaint.length : (Complaint.self || []).length + (Complaint.team || []).length) : 0;

//             const response = await axios.get(`${path}/api/complain-details`, {
//                 params: {
//                     ...usedFilters,
//                     limit: batch,
//                     offset,
//                     userId: userId,
//                     companyId: companyId,
//                     role: role,
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });

//             let fetchedRecords = response.data.records || [];

//             // Sort records based on role
//             fetchedRecords = role === "Team Leader" ? sortRecordsForTeamLeader(fetchedRecords, userId) : fetchedRecords.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));

//             if (role === "Team Leader") {
//                 const { self, team } = splitRecordsForTeamLeader(fetchedRecords, userId);
//                 setComplaint((prev) => ({ self: isLoadMore ? [...(prev?.self || []), ...self] : self, team: isLoadMore ? [...(prev?.team || []), ...team] : team, }));
//             } else {
//                 setComplaint(isLoadMore ? [...Complaint, ...fetchedRecords] : fetchedRecords);
//             }

//             if (role === "Team Leader") {
//                 const currentCount = (response.data.records || []).length;
//                 setDisplayedRecords(prev => isLoadMore ? prev + currentCount : currentCount);
//             } else {
//                 setDisplayedRecords(fetchedRecords.length);
//             }
//             setTotalRecords(response.data.total);
//         } catch (error) {
//             console.error("Error fetching Complaint:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ----------------------- Event Handlers -----------------------
//     const handleAddBtn = () => {
//         console.log("Mode: Insert");
//         navigate("/main/complainInsert", { state: { mode: "insert" } });
//     };

//     const handleRowClick = (complain) => {
//         console.log(complain);
//         navigate("/main/edit-complainInsert", { state: { mode: "edit", ComplainData: { complain } } });
//     };

//     const handleSelectAll = (e, data) => {
//         if (e.target.checked) {
//             const allIds = data.map((rec) => rec.complainId);
//             console.log("In handleSelectAll:", allIds);
//             setSelectedIds(allIds);
//         } else {
//             setSelectedIds([]);
//         }
//     };

//     const handleRowCheckboxChange = (e, id) => {
//         if (e.target.checked) {
//             setSelectedIds((prev) => [...prev, id]);
//         } else {
//             setSelectedIds((prev) => prev.filter((item) => item !== id));
//         }
//     };

//     const handleDelete = async () => {
//         if (selectedIds.length === 0) {
//             alert("Please select at least one record.");
//         } else {
//             try {
//                 const res = await axios.post(`${path}/api/Compt-followupCount`, { complainIds: selectedIds });
//                 const invalidIds = [];
//                 const validIds = [];
//                 res.data.forEach((item) => {
//                     if (item.count === 1) {
//                         validIds.push(item.inqid);
//                     } else {
//                         invalidIds.push(item.inqid);
//                     }
//                 });

//                 console.log("Valid IDs for deletion:", validIds);
//                 console.log("Invalid IDs (Count > 1):", invalidIds);

//                 if (invalidIds.length > 0) {
//                     setSuccessMessage(`Cannot delete: ${invalidIds.join(", ")} (More than 1 follow-up)`);
//                 } else {
//                     const deleteResponse = await axios.post(`${path}/api/deleteComplaint`, { complainIds: validIds });
//                     if (deleteResponse.status === 200) {
//                         setSuccessMessage("Complaint deleted successfully!");
//                         if (role === "Team Leader") {
//                             setComplaint((prevComplaint) => ({
//                                 self: prevComplaint.self.filter(c => !validIds.includes(c.complainId)),
//                                 team: prevComplaint.team.filter(c => !validIds.includes(c.complainId)),
//                             }));
//                         } else {
//                             setComplaint((prevComplaint) => prevComplaint.filter((complain) => !validIds.includes(complain.complainId)));
//                         }
//                         setSelectedIds([]);
//                     } else {
//                         setSuccessMessage("Failed to delete Complaint.");
//                     }
//                     console.log("Deletion response:", deleteResponse.data);
//                 }
//             } catch (error) {
//                 console.error("Error during deletion:", error);
//                 setSuccessMessage("Error deleting Complaint.");
//             }
//         }
//     };

//     // ----------------------- Render Functions -----------------------
//     const columns = [
//         {
//             field: "checkbox", headerName: "", minWidth: 60, flex: 0.3, sortable: false, filterable: false,
//             renderHeader: () => (
//                 <Checkbox
//                     onChange={(e) => handleSelectAll(e, role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint)}
//                     checked={(role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint).length > 0 &&
//                         (role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint).every((complain) => selectedIds.includes(complain.complainId))}
//                 />
//             ),
//             renderCell: (params) => (
//                 <Checkbox value={params.row.complainId} onChange={(e) => handleRowCheckboxChange(e, params.row.complainId)} checked={selectedIds.includes(params.row.complainId)} onClick={(e) => e.stopPropagation()} />
//             ),
//         },
//         {
//             field: "index", headerName: "#", minWidth: 70, flex: 0.5, align: "center", sortable: false, filterable: false,
//             renderCell: (params) => {
//                 console.log("Params", params.id);
//                 const rowIndex = params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
//                 return <Typography sx={{ width: "100%", textAlign: "center" }}>{rowIndex}</Typography>;
//             },
//         },
//         {
//             field: "complainNumber",
//             headerName: "Complain No",
//             minWidth: 120,
//             flex: 1,
//             renderCell: (params) =>
//                 params.row?.complainNumber || "N/A",
//         },
//         { field: "complainDate", headerName: "Complain Date", minWidth: 120, flex: 1, renderCell: (params) => formatDate(params.value || params.row.AddUserDateTime), },
//         { field: "LastFollowUpDate", headerName: "Follow-Up Date", minWidth: 120, flex: 1, renderCell: (params) => formatDate(params.value || "N/A"), },
//         {
//             field: "statusName",
//             headerName: "Status",
//             minWidth: 100,
//             flex: 0.8,
//             renderCell: (params) => {
//                 const statusText = params.row?.statusName || "N/A";
//                 const color = getPriorityColor(statusText);

//                 return (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         <Box
//                             sx={{
//                                 width: 10,
//                                 height: 10,
//                                 borderRadius: "50%",
//                                 bgcolor: color,
//                             }}
//                         />
//                         <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
//                             {statusText}
//                         </Typography>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: "clientInfo", headerName: "Client", minWidth: 300, flex: 2, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 const row = params.row || {};
//                 const name = row.clientname || row.FirmName || "N/A";
//                 const contact = row.clientContact || row.ContactPerson || "N/A";
//                 const mobile = row.mobileNo || row.MobileNo || "N/A";
//                 const email = row.emailId || row.EmailId || "N/A";
//                 return (
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                         <Typography
//                             variant="subtitle2"
//                             component="span"
//                             onClick={(e) => { e.stopPropagation(); handleRowClick(row); }}
//                             sx={{
//                                 fontWeight: 700,
//                                 color: "primary.main",
//                                 textDecoration: "underline",
//                                 cursor: "pointer",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 whiteSpace: "normal",
//                                 wordBreak: "break-word",
//                                 '&:hover': { opacity: 0.9 }
//                             }}
//                         >
//                             {name}
//                         </Typography>
//                         <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {contact} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PhoneIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {mobile} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <EmailIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {email} </Typography>
//                             </Box>
//                         </Box>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: "priority",
//             headerName: "Priority",
//             minWidth: 100,
//             flex: 0.8,
//             renderCell: (params) => {
//                 const priorityText = params.row?.priority || "N/A";
//                 const color = getPriorityColor(priorityText);

//                 return (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {renderPriorityIcon(priorityText)}
//                         <Typography variant="body2" sx={{ color, fontWeight: "bold" }}>
//                             {priorityText}
//                         </Typography>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: "LastemployeeName",
//             headerName: "Assign",
//             minWidth: 120,
//             flex: 1,
//             renderCell: (params) =>
//                 params.row?.LastemployeeName || "Unassigned",
//         },
//     ];

//     const HL_FN_RenderDesktopTable = (data) => (
//         <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "auto", p: 2 }}>
//             <DataGrid
//                 rows={data.map((record) => ({ ...record }))}
//                 columns={columns}
//                 getRowId={(row) => row.complainId}
//                 pageSizeOptions={[10, 25, 50]}
//                 autoHeight
//                 disableSelectionOnClick
//                 onRowClick={(params) => handleRowClick(params.row)}
//                 getRowHeight={() => "auto"}
//                 sx={{
//                     "& .MuiDataGrid-cell": {
//                         cursor: "pointer",
//                         whiteSpace: "normal",
//                         lineHeight: 1.4,
//                         py: 1,
//                         alignItems: "flex-start",
//                         display: "flex",
//                     },
//                     "& .MuiDataGrid-columnHeader": { backgroundColor: "grey.400" },
//                     width: "100%",
//                 }}
//             />
//         </Box>
//     );

//     const HL_FN_RenderMobileCard = (data) => (
//         <Box sx={{ py: 2, maxWidth: { xs: "100%", sm: 600, md: 800 }, mx: "auto", px: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                 <Checkbox onChange={(e) => handleSelectAll(e, data)} checked={data.length > 0 && data.every((complain) => selectedIds.includes(complain.complainId))} />
//                 <Typography variant="subtitle1">Select All</Typography>
//             </Box>
//             {data.map((complain, index) => (
//                 <Card key={complain.complainId} variant="outlined" onClick={() => handleRowClick(complain)}
//                     sx={{ cursor: "pointer", boxShadow: 3, borderRadius: 2, mb: 2, p: 2, transition: "0.3s", "&:hover": { boxShadow: 6 }, width: "100%", maxWidth: "100%", }}
//                 >
//                     <CardContent sx={{ px: 0, pt: 0 }}>
//                         <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                             <Checkbox sx={{ mr: 1 }} value={complain.complainId} onClick={(e) => e.stopPropagation()} onChange={(e) => handleRowCheckboxChange(e, complain.complainId)} checked={selectedIds.includes(complain.complainId)} />
//                             <Typography variant="h6" sx={{ flexGrow: 1, fontSize: { xs: "1rem", sm: "1.1rem" } }}> #{index + 1} - {complain.complainNumber} </Typography>
//                             {renderPriorityIcon(complain.priority)}
//                         </Box>
//                         <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <CalendarTodayIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Complaint Date:</strong> {formatDate(complain.complainDate)} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <CalendarTodayIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Follow-Up:</strong> {formatDate(complain.LastFollowUpDate)} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Client:</strong> {complain.clientname || complain.FirmName || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Contact:</strong> {complain.clientContact || complain.ContactPerson || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PhoneIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Mobile:</strong> {complain.mobileNo || complain.MobileNo || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <EmailIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Email:</strong> {complain.emailId || complain.EmailId || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Status:</strong> {complain.statusName || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Priority:</strong> </Typography>
//                                 <Typography variant="body2" sx={{ color: getPriorityColor(complain.priority), fontWeight: "bold", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> {complain.priority || "N/A"} </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                                 <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
//                                 <Typography variant="body2" sx={{ color: "grey.800", fontSize: { xs: "0.85rem", sm: "0.9rem" } }}> <strong>Assign:</strong> {complain.LastemployeeName || "Unassigned"} </Typography>
//                             </Box>
//                         </Box>
//                     </CardContent>
//                 </Card>
//             ))}
//         </Box>
//     );

//     const FN_RenderTable = (data) => {
//         if (!data || data.length === 0) {
//             return (
//                 <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
//                     <Typography variant="h5" color="text.secondary"> No records found. </Typography>
//                 </Box>
//             );
//         }
//         return windowWidth < 1024 ? HL_FN_RenderMobileCard(data) : HL_FN_RenderDesktopTable(data);
//     };

//     let mergedComplaint = [];
//     if (role === "Team Leader") {
//         mergedComplaint = [...(Complaint.self || []), ...(Complaint.team || [])];
//     }

//     return (
//         <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>

//             {/* Toolbar */}
//             <Box sx={{ position: 'relative', mb: 0.7 }}>
//                 {/* Title - Centered */}
//                 <Typography
//                     variant="h5"
//                     sx={{
//                         textAlign: 'center',
//                         fontSize: { xs: '1.25rem', sm: '1.5rem' },
//                         fontWeight: 600
//                     }}
//                 >
//                     Complaint Details
//                 </Typography>

//             </Box>

//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//                 <Typography variant="body1"> {role === "Team Leader" ? `Total: ${mergedComplaint.length} / ${totalRecords}` : `Count: ${displayedRecords} / ${totalRecords}`} </Typography>
//                 <Box sx={{ display: "flex", gap: 1 }}>
//                     <Button variant="contained" color="error" onClick={handleDelete}> Delete </Button>
//                     {displayedRecords < totalRecords && (<Button variant="contained" color="primary" onClick={() => fetchComplaint(true)}> Show More </Button>)}
//                 </Box>
//             </Box>
//             {loading ? (
//                 <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
//                     <CircularProgress />
//                 </Box>
//             ) : role === "Team Leader" ? (
//                 <Box>{FN_RenderTable(mergedComplaint)}</Box>
//             ) : (
//                 <Box>{FN_RenderTable(Complaint)}</Box>
//             )}
//             <Snackbar open={!!successMessage} autoHideDuration={4000} onClose={() => setSuccessMessage("")} message={successMessage}
//                 action={<button onClick={() => setSuccessMessage("")} style={{ color: "white" }}> Close </button>}
//             />
//         </Box>
//     );
// };

// export default ComplainDetails;




import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AiOutlinePlus } from "react-icons/ai";
import Snackbar from '@mui/material/Snackbar';
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from '../context/AuthContext';

// MUI components
import {
    Container, Paper, Box, Grid, Typography, Card, CardContent, Button, Checkbox, CircularProgress, Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Alert,
    TextField,
    InputAdornment
} from "@mui/material";

// MUI Icons used in mobile cards and DataGrid
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import { height, useMediaQuery, useTheme } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Tooltip } from "@mui/material";
import { toProperCase } from "../utils/formatRows";
import { useRef } from "react";
import SearchIcon from '@mui/icons-material/Search';
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
// Helper function to format dates to dd-mm-yyyy
const formatDate = (dateString) => {
    if (!dateString || dateString === "N/A") return "N/A";
    try {
        // Handle both 'yyyy-mm-dd' and 'yyyy-mm-dd hh:mm:ss' formats
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "N/A"; // Invalid date
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    } catch (error) {
        console.error("Error formatting date:", dateString, error);
        return "N/A";
    }
};

// Helper function to split records for team leader
const splitRecordsForTeamLeader = (records, userId) => {
    const selfRecords = records.filter((record) => record.userId === userId);
    const teamRecords = records.filter((record) => record.userId !== userId);
    return { self: selfRecords, team: teamRecords };
};

// Helper function to sort records for team leader
const sortRecordsForTeamLeader = (records, userId) => {
    const recs = Array.isArray(records) ? records : [];
    return recs.sort((a, b) => {
        const aIsSelf = a.userId === userId;
        const bIsSelf = b.userId === userId;
        if (aIsSelf && !bIsSelf) return -1;
        if (!aIsSelf && bIsSelf) return 1;
        const dateA = new Date(a.AddUserDateTime || "1970-01-01");
        const dateB = new Date(b.AddUserDateTime || "1970-01-01");
        return dateB - dateA;
    });
};

// Helper: Return a color based on priority or status
const getPriorityColor = (priority) => {
    if (!priority) return "gray";
    const p = String(priority).toLowerCase().trim();
    if (p === "open") return "#388e3c"; // green
    if (p === "close" || p === "closed") return "#d32f2f"; // red
    switch (p) {
        case "high": return "#d32f2f"; // red
        case "medium": return "#fbc02d"; // amber
        case "low": return "#388e3c"; // green
        default: return "gray";
    }
};

// Helper: Render a priority icon based on priority
const renderPriorityIcon = (priority) => {
    const color = getPriorityColor(priority);
    if (!priority) return null;
    switch (priority.toLowerCase()) {
        case "high": return <PriorityHighIcon sx={{ color, mr: 0.5 }} />;
        case "medium": return <ReportProblemIcon sx={{ color, mr: 0.5 }} />;
        case "low": return <LowPriorityIcon sx={{ color, mr: 0.5 }} />;
        default: return null;
    }
};

const ComplainDetails = ({ connectionString }) => {
    const { user, selectedCompany } = useAuth();
    const path = connectionString;
    // ----------------------- State Variables -----------------------
    const [Complaint, setComplaint] = useState([]);
    const [filters, setFilters] = useState({ complainDate: "", status: "", priority: "", clientname: "", clientContact: "", mobileNo: "" });
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState(0);

    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [successMessage, setSuccessMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [loading, setLoading] = useState(false);
    const [statusOptions, setStatusOptions] = useState([]);
    const [priorityOptions, setPriorityOptions] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);

    const [selectedIds, setSelectedIds] = useState([]);

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const selectedIdsRef = useRef([]);

    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory || null;

    // ----------------------- Data Fetching and Side Effects -----------------------
    useEffect(() => {
        axios.get(`${path}/api/status`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.data)) {
                    setStatusOptions(res.data.data);
                } else {
                    setStatusOptions([]);
                }
            })
            .catch((error) => console.error("Error fetching status:", error));

        axios.get(`${path}/api/priority`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.data)) {
                    setPriorityOptions(res.data.data);
                } else {
                    setPriorityOptions([]);
                }
            })
            .catch((error) => console.error("Error fetching priority options:", error));

    }, []);


    useEffect(() => {
        if (!isSmallScreen) fetchComplaintDesktop();
    }, [paginationModel.page, paginationModel.pageSize, isSmallScreen]);

    useEffect(() => {
        if (isSmallScreen) fetchComplaintMobile();
    }, [mobilePaginationModel, isSmallScreen]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel(p => ({ ...p, page: 0 }));
        }, 400);
        return () => clearTimeout(timer);
    }, [mobileSearchQuery]);

    useEffect(() => {
        if (isSmallScreen) fetchComplaintMobile();
    }, [debouncedMobileSearch, isSmallScreen]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") return;
        setSuccessMessage("")
    };

    // ----------------------- Function: fetchComplaint -----------------------

    const fetchComplaintDesktop = async () => {
        if (isSmallScreen) return;
        setLoading(true);
        try {
            const response = await axios.get(`${path}/api/complain-details`, {
                params: {
                    userId, companyId, role,
                    limit: paginationModel.pageSize,
                    offset: paginationModel.page * paginationModel.pageSize,
                },
                headers: { 'Cache-Control': 'no-store' }
            });

            let fetchedRecords = response.data.records || [];
            fetchedRecords = role === "Team Leader"
                ? sortRecordsForTeamLeader(fetchedRecords, userId)
                : fetchedRecords.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));

            if (role === "Team Leader") {
                const { self, team } = splitRecordsForTeamLeader(fetchedRecords, userId);
                setComplaint({ self, team });
            } else {
                setComplaint(fetchedRecords);
            }
            setTotalRecords(response.data.total || 0);
        } catch (error) {
            console.error("Error fetching complaints (desktop):", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchComplaintMobile = async () => {
        if (!isSmallScreen) return;
        setLoading(true);
        try {
            const response = await axios.get(`${path}/api/complain-details`, {
                params: {
                    userId, companyId, role,
                    limit: mobilePaginationModel.pageSize,
                    offset: mobilePaginationModel.page * mobilePaginationModel.pageSize,
                    ...(debouncedMobileSearch ? { search: debouncedMobileSearch } : {})
                },
                headers: { 'Cache-Control': 'no-store' }
            });

            let fetchedRecords = response.data.records || [];
            fetchedRecords = role === "Team Leader"
                ? sortRecordsForTeamLeader(fetchedRecords, userId)
                : fetchedRecords.sort((a, b) => new Date(b.AddUserDateTime || "1970-01-01") - new Date(a.AddUserDateTime || "1970-01-01"));

            if (role === "Team Leader") {
                const { self, team } = splitRecordsForTeamLeader(fetchedRecords, userId);
                setComplaint({ self, team });
            } else {
                setComplaint(fetchedRecords);
            }
            setTotalRecords(response.data.total || 0);
        } catch (error) {
            console.error("Error fetching complaints (mobile):", error);
        } finally {
            setLoading(false);
        }
    };

    // ----------------------- Event Handlers -----------------------
    const handleAddBtn = () => {
        console.log("Mode: Insert");
        navigate("/main/complainInsert", { state: { mode: "insert" } });
    };

    const handleRowClick = (complain) => {
        console.log(complain);
        navigate("/main/edit-complainInsert", { state: { mode: "edit", ComplainData: { complain } } });
    };

    const handleSelectAll = (e, data) => {
        if (e.target.checked) {
            const allIds = data.map((rec) => rec.complainId);
            setSelectionModel(allIds);
            selectedIdsRef.current = allIds;
        } else {
            setSelectionModel([]);
            selectedIdsRef.current = [];
        }
    };

    const handleRowCheckboxChange = (e, id) => {
        setSelectionModel(prev => {
            const updated = e.target.checked
                ? [...prev, id]
                : prev.filter(item => item !== id);
            selectedIdsRef.current = updated;
            return updated;
        });
    };
    const handleDelete = async () => {
        const ids = selectedIdsRef.current;

        if (ids.length === 0) return;

        try {
            const res = await axios.post(`${path}/api/Compt-followupCount`, { complainIds: ids });
            const invalidIds = [];
            const validIds = [];

            res.data.forEach((item) => {
                if (item.count === 1) {
                    validIds.push(item.complainId);
                } else {
                    invalidIds.push(item.complainId);
                }
            });

            console.log("Valid IDs for deletion:", validIds);
            console.log("Invalid IDs (Count > 1):", invalidIds);

            // ✅ Delete if valid
            if (validIds.length > 0) {
                const deleteResponse = await axios.post(`${path}/api/deleteComplaint`, { complainIds: validIds });

                if (deleteResponse.status === 200) {
                    setSelectedIds([]);
                    if (isSmallScreen) fetchComplaintMobile();
                    else fetchComplaintDesktop();

                    setSuccessMessage("Deleted successfully!");
                    setSnackbarSeverity("success")
                } else {
                    setSuccessMessage("Failed to delete.");
                    setSnackbarSeverity("error")
                }
            } else {
                // ✅All invalid
                setSuccessMessage(`Cannot delete the selected item(s) because they have multiple followups.`);
                setSnackbarSeverity("warning")
            }

        } catch (error) {
            console.error("Error during deletion:", error);
            setSuccessMessage("Error deleting Complaint.");
            setSnackbarSeverity("error")
        } finally {
            setConfirmOpen(false);
        }
    };
    // ----------------------- Render Functions -----------------------
    const columns = [
        {
            field: "checkbox", headerName: "", minWidth: 65, flex: 0.3, sortable: false, filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={(e) => handleSelectAll(e, role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint)}
                    checked={(role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint).length > 0 &&
                        (role === "Team Leader" ? [...(Complaint.self || []), ...(Complaint.team || [])] : Complaint).every((complain) => selectionModel.includes(complain.complainId))}
                />
            ),
            renderCell: (params) => (
                <Checkbox value={params.row.complainId} onChange={(e) => handleRowCheckboxChange(e, params.row.complainId)} checked={selectionModel.includes(params.row.complainId)} onClick={(e) => e.stopPropagation()} />
            ),
        },
        {
            field: "index", headerName: "#", minWidth: 50, flex: 0.5, align: "center", sortable: false, filterable: false,
            renderCell: (params) => {
                console.log("Params", params.id);
                const rowIndex = params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
                return <Typography sx={{ width: "100%", textAlign: "center" }}>{rowIndex}</Typography>;
            },
        },
        {
            field: "complainNumber",
            headerName: "Complain No",
            minWidth: 120,
            flex: 1,
            renderCell: (params) =>
                params.row?.complainNumber || "N/A",
        },
        { field: "complainDate", headerName: "Complain Date", minWidth: 100, flex: 1, renderCell: (params) => formatDate(params.value || params.row.AddUserDateTime), },
        { field: "LastFollowUpDate", headerName: "Follow-Up Date", minWidth: 100, flex: 1, renderCell: (params) => formatDate(params.value || "N/A"), },
        {
            field: "statusName",
            headerName: "Status",
            minWidth: 60,
            flex: 0.8,
            renderCell: (params) => {
                const statusText = params.row?.statusName || "N/A";
                const color = getPriorityColor(statusText);

                return (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                        <Typography variant="body2" sx={{ textTransform: "capitalize", color: color, fontWeight: 600 }}>
                            {statusText}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "clientInfo", headerName: "Client", minWidth: 200, flex: 2, sortable: false, filterable: true,

            valueGetter: (value, row) =>
                row?.clientname || row?.FirmName || "",

            renderCell: (params) => {
                const row = params.row || {};
                const name = row.clientname || row.FirmName || "N/A";
                const contact = row.clientContact || row.ContactPerson || "N/A";
                const mobile = row.mobileNo || row.MobileNo || "N/A";
                const email = row.emailId || row.EmailId || "N/A";
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <Typography
                            variant="subtitle2"
                            component="span"
                            onClick={(e) => { e.stopPropagation(); handleRowClick(row); }}
                            sx={{
                                fontWeight: 700,
                                color: "primary.main",
                                textDecoration: "underline",
                                cursor: "pointer",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                '&:hover': { opacity: 0.9 }
                            }}
                        >
                            {toProperCase(name)}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <PersonIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {contact} </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <PhoneIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {mobile} </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                <EmailIcon sx={{ fontSize: 16, color: "grey.600" }} />
                                <Typography variant="body2" sx={{ color: "grey.800", whiteSpace: "normal" }}> {email} </Typography>
                            </Box>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: "priority",
            headerName: "Priority",
            minWidth: 80,
            flex: 0.8,
            renderCell: (params) => {
                const priorityText = params.row?.priority || "N/A";
                const color = getPriorityColor(priorityText);

                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {renderPriorityIcon(priorityText)}
                        <Typography variant="body2" sx={{ color, fontWeight: "bold" }}>
                            {priorityText}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "LastemployeeName",
            headerName: "Assign",
            minWidth: 100,
            flex: 1,
            renderCell: (params) =>
                params.row?.LastemployeeName || "Unassigned",
        },
        {
            field: "actions",
            headerName: "",
            minWidth: 80,
            flex: 0.4,
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",

            renderCell: (params) => {
                const isSelected = selectionModel.includes(params.row.complainId);

                return (
                    <Tooltip title={isSelected ? "Delete selected" : "Select row first"}>
                        <span>
                            <IconButton
                                color="error"
                                disabled={!isSelected}
                                // onClick={(e) => {
                                //     e.stopPropagation();
                                //     handleDelete();   // 🔥 tumhara existing delete logic
                                // }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    selectedIdsRef.current = selectionModel;
                                    setConfirmOpen(true);
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            }
        }

    ];

    const HL_FN_RenderDesktopTable = (data) => (
        <Box sx={{ height: '81.5vh', width: '100%' }}>
            <DataGrid
                rows={data.map((record) => ({ ...record }))}
                columns={columns}
                getRowId={(row) => row.complainId}
                paginationMode="server"
                rowCount={totalRecords}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10, 25, 50]}
                loading={loading}
                disableSelectionOnClick
                onRowClick={(params) => handleRowClick(params.row)}
                getRowHeight={() => "auto"}
                sx={{
                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                    '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                    // Background styling
                    '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                    '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                    // Row styling
                    '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                    '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                    // Selected row styling (with !important to override default MUI)
                    '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

                    // Cell content alignment
                    '& .MuiDataGrid-cell': {
                        display: 'flex',
                        alignItems: 'center'
                    },
                }}
                slots={{
                    noResultsOverlay: CustomNoDataOverlay
                }}
            />
        </Box>
    );

    const HL_FN_RenderMobileCard = (data) => {
        // ✅ Name filter - client side
        const filteredData = mobileSearchQuery.trim()
            ? data.filter(row =>
                (row.clientname || row.FirmName || '').toLowerCase().includes(mobileSearchQuery.toLowerCase()) ||
                (row.complainNumber || '').toLowerCase().includes(mobileSearchQuery.toLowerCase())
            )
            : data;

        return (
            <Box sx={{ py: 2, maxWidth: { xs: "100%" }, mx: "auto", px: 2 }}>

                {/* Search Bar */}
                <Box sx={{ mb: 2 }}>
                    <TextField
                        fullWidth size="small"
                        placeholder="Search by name or complaint no..."
                        value={mobileSearchQuery}
                        onChange={(e) => setMobileSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start"><SearchIcon /></InputAdornment>
                            ),
                        }}
                        variant="outlined"
                    />
                </Box>

                {/* Delete + Select All Row */}
                {role !== 'User' && (
                    selectionModel.length > 0 && (<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Checkbox
                                checked={filteredData.length > 0 && filteredData.every(c => selectionModel.includes(c.complainId))}
                                indeterminate={
                                    selectionModel.length > 0 &&
                                    !filteredData.every(c => selectionModel.includes(c.complainId))
                                }
                                onChange={(e) => handleSelectAll(e, filteredData)}
                            />
                            <Typography variant="subtitle2">
                                {`${selectionModel.length} selected`}
                            </Typography>
                        </Box>
                        {selectionModel.length > 0 && (
                            <Tooltip title="Delete selected">
                                <IconButton color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        selectedIdsRef.current = selectionModel;
                                        setPendingDeleteIds(selectionModel);
                                        setConfirmOpen(true);
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>)


                )}

                {/* Cards */}
                {filteredData.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography color="text.secondary">No records found.</Typography>
                    </Box>
                ) : (
                    filteredData.map((row) => {
                        const isSelected = selectionModel.includes(row.complainId);
                        const toggleSelection = (e) => {
                            e.stopPropagation();
                            setSelectionModel(prev => {
                                const updated = prev.includes(row.complainId)
                                    ? prev.filter(id => id !== row.complainId)
                                    : [...prev, row.complainId];
                                selectedIdsRef.current = updated;
                                return updated;
                            });
                        };

                        return (
                            <Card key={row.complainId}
                                sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, cursor: 'pointer' }}
                                onClick={() => handleRowClick(row)}
                            >
                                <CardContent sx={{ py: 1.8, px: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                                        {role !== 'User' && (
                                            <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" sx={{ p: 0.5 }} />
                                        )}
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2', fontSize: '0.95rem' }}>
                                            {row.complainNumber || '—'}
                                        </Typography>
                                        <Box sx={{ flex: 1 }} />
                                        {renderPriorityIcon(row.priority)}
                                    </Box>

                                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                                        {row.clientname || row.FirmName || '—'}
                                    </Typography>

                                    <Typography variant="caption" color="text.secondary">
                                        {formatDate(row.complainDate)} • {formatDate(row.LastFollowUpDate)}
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                        <Typography variant="caption" color="text.secondary">
                                            {row.mobileNo || '—'}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: getPriorityColor(row.statusName), fontWeight: 600 }}>
                                            {row.statusName || '—'}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        );
                    })
                )}

                {/* Pagination */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2 }}>
                    <Button variant="outlined" size="small"
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))}
                        disabled={mobilePaginationModel.page === 0}>
                        ← Prev
                    </Button>
                    <Typography variant="body2">
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalRecords / mobilePaginationModel.pageSize) || 1}
                    </Typography>
                    <Button variant="outlined" size="small"
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))}
                        disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalRecords}>
                        Next →
                    </Button>
                </Box>
            </Box>
        );
    };

    const FN_RenderTable = (data) => {
        if (!data || data.length === 0) {
            return (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
                    <Typography variant="h5" color="text.secondary"> No records found. </Typography>
                </Box>
            );
        }
        return windowWidth < 1024 ? HL_FN_RenderMobileCard(data) : HL_FN_RenderDesktopTable(data);
    };

    let mergedComplaint = [];
    if (role === "Team Leader") {
        mergedComplaint = [...(Complaint.self || []), ...(Complaint.team || [])];
    }



    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>

            {/* Toolbar */}
            <Box sx={{ position: 'relative', mb: 0.7 }}>
                {/* Title - Centered */}
                <Typography
                    variant="h5"
                    sx={{
                        textAlign: 'center',
                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                        fontWeight: 600
                    }}
                >
                    Complaint Details
                </Typography>

            </Box>

            {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="body1"> {role === "Team Leader" ? `Total: ${mergedComplaint.length} / ${totalRecords}` : `Count: ${displayedRecords} / ${totalRecords}`} </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="contained" color="error" onClick={handleDelete}> Delete </Button>
                    {displayedRecords < totalRecords && (<Button variant="contained" color="primary" onClick={() => fetchComplaint(true)}> Show More </Button>)}
                </Box>
            </Box> */}

            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                            <CircularProgress />
                        </Box>
                    ) : role === "Team Leader" ? (
                        <Box style={{ height: "81.5vh" }}>{FN_RenderTable(mergedComplaint)}</Box>
                    ) : (
                        <Box>{FN_RenderTable(Complaint)}</Box>
                    )}
                </Box>
            </Paper>
            {/* <Snackbar open={!!successMessage} autoHideDuration={4000} onClose={() => setSuccessMessage("")} message={successMessage}
                action={<button onClick={() => setSuccessMessage("")} style={{ color: "white" }}> Close </button>}
            /> */}

            <Snackbar open={!!successMessage} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ whiteSpace: "pre-line" }}>
                <Alert severity={snackbarSeverity} variant="filled">
                    {successMessage}
                </Alert>

            </Snackbar>

            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete {selectedIdsRef.current.length} record(s)?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={handleDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ComplainDetails;